import Box from '@totallymoney/ui/components/Box'
import LinkButton from '@totallymoney/ui/components/LinkButton'

import useAppQueryState from '@hooks/useAppQueryState'

import ErrorPage from '@components/ErrorPage/ErrorPage'

const UnscoredTableError = () => {
    const { getRoutePath } = useAppQueryState()

    return (
        <ErrorPage
            title="Oh! This doesn’t look right"
            subtitle="Sorry, the page you requested hit an error. "
        >
            <Box pt="space30" maxWidth={['100%', '280px']}>
                <LinkButton
                    variant="primary"
                    text="Try to search again"
                    href={getRoutePath('')}
                />
            </Box>
        </ErrorPage>
    )
}

export default UnscoredTableError
